import { ChevronLeftIcon } from "@chakra-ui/icons";
import { HStack, Link } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { usePortalEventUrls } from "../usePortalEventUrls";

export const BackToListingLink = () => {
  const { t } = useTranslation();
  const portalUrls = usePortalEventUrls();
  return (
    <Link
      as={RouterLink}
      to={portalUrls.list}
      color="smPrimary"
      fontSize="sm"
      fontWeight="semibold"
      _hover={{ textDecoration: "none", color: "smPrimarySoft" }}
    >
      <HStack spacing="1">
        <ChevronLeftIcon boxSize="4" />
        <span>{t("All procurements")}</span>
      </HStack>
    </Link>
  );
};
